<template>
	<div>
		<div class="transparent">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li>
									<LangSwitch type="single" v-bind:downloadCallback="getMarketsCompleteHandler" v-bind:callback="langChanged"></LangSwitch>
								</li>
								<li>
									<button class="btn" type="button" @click="createAllCaches">Create all cache</button>
								</li>
								<li>
									<button class="btn" type="button" @click="deleteAllCaches">Delete all cache</button>
								</li>
							</ul>
						</nav>

					</div>

				</div>
			</div>
		</div>

		<template v-for="(structure, key) in sitemapFiltered">
			<template v-if="structure">
				<h2 class="title-offset" :key="key">{{structure[0].page_structure}}</h2>
				<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup" :key="key + 1">
					<thead>
					<tr>
						<th></th>
						<th>Page</th>
						<th>In cache</th>
						<th>Enabled caching</th>
						<th></th>
					</tr>
					</thead>

					<tbody>

						<template v-for="(page, index) in structure">
							<tr :key="index">
								<td>
								</td>
								<td>
									<span v-html="page.page_title"></span>
									<a :href="user.project.domains[Object.keys(user.project.domains)[0]].domain + page.page_url" target="livePreview" class="btn-cms-open path">{{page.page_url}}</a>
								</td>
								<td>
									<span class="status" :class="{ 'active' : page.cached, 'load' : page.loading === true }"></span>
									<div v-if="page.cached" class="description" style="display: inline-block">{{page.cached}}</div>
								</td>
								<td>
									<button class="btn-switch" :class="{ 'active' : page.cacheable === 'true' || page.cacheable === null}" @click="toggleCaching" :data-url="page.page_url"></button>
								</td>
								<td class="btns">
									<button type="button" @click="fetchSpecificCache" :data-url="page.page_url" :disabled="page.loading"><i class="fa fa-file-medical"></i></button>
									<button type="button" :id="page.page_url" class="btn-delete-confirm fa fa-trash-alt" :disabled="!page.cached"></button>
								</td>
								<td></td>
							</tr>
						</template>

					</tbody>
				</table>
			</template>
		</template>

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteSpecificCache">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>
	</div>
</template>

<script>

import LangSwitch from '../../components/LangSwitch.vue'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'caching',

	data () {
		return {
			sitemap: null,
			markets: null,
			activeLanguage: null,
			sitemapFiltered: {},
			user: this.$store.state.user
		}
	},

	components: {
		'LangSwitch': LangSwitch
	},

	created () {
		this.body = document.querySelector('body')
		this.body.classList.add('loading')
		this.setup()
	},

	methods: {
		setup () {
			this.cacheFetchDone = false
			this.sitemapFilterDone = false
			this.fetchSitemap()
			this.fetchCacheFiles()
		},

		fetchSitemap () {
			var url = '/cms/api/sitemap'
			xhrModule.get(url, this.sitemapFetchCompleted.bind(this))
		},

		fetchCacheFiles () {
			this.startedInt = 0
			this.finishedInt = 0
			var url = '/cms/api/cache/getCachedPages'
			xhrModule.get(url, this.cacheFetchCompleted.bind(this))
		},

		cacheFetchCompleted (data) {
			this.caches = data.data
			this.cacheFetchDone = true
			this.combineData()
		},

		getMarketsCompleteHandler (markets) {
			this.markets = markets.data
		},

		sitemapFetchCompleted (data) {
			this.sitemap = data.data
			if (this.activeLanguage) this.filterData()
			this.body.classList.remove('loading')
		},

		langChanged (lang) {
			this.activeLanguage = lang
			if (this.sitemap) this.filterData()
			this.body.classList.remove('loading')
		},

		filterData () {
			for (var key in this.sitemap) {
				this.sitemapFiltered[key] = this.sitemap[key][this.activeLanguage.locale]
			}
			this.sitemapFilterDone = true
			this.combineData()
		},

		combineData () {
			var today = new Date()
			if (this.cacheFetchDone && this.sitemapFilterDone) {
				for (var key in this.sitemapFiltered) {
					if (!this.sitemapFiltered[key]) continue
					for (var i = this.sitemapFiltered[key].length - 1; i >= 0; i--) {
						for (var c = this.caches.length - 1; c >= 0; c--) {
							if (this.sitemapFiltered[key][i].page_url === this.caches[c].file) {
								var duration = general.numDaysBetween(this.caches[c].modified, today)
								this.sitemapFiltered[key][i].cached = duration
								this.sitemapFiltered[key][i].loading = false
							}
						}

						if (i === 0) {
							this.$forceUpdate()
						}
					}
				}
			}
		},

		createAllCaches (e) {
			// cache files genereren voor alle URL's van de site
			// dit kan je niet in 1 request doen... (gateway timeout)
			this.body.classList.add('loading')
			var url = '/cms/api/cache/createAllPages'
			xhrModule.get(url, this.createAllCacheCompleted.bind(this), this.createAllCacheFailed.bind(this))
		},

		createAllCacheCompleted (data) {
			console.log('success data: ', data)
			this.body.classList.remove('loading')
			this.fetchCacheFiles()
		},

		createAllCacheFailed (data) {
			console.log('fail data: ', data)
			this.body.classList.remove('loading')
			this.fetchCacheFiles()
		},

		deleteAllCaches (e) {
			this.body.classList.add('loading')
			var url = '/cms/api/cache/purgeCachedPages'
			xhrModule.get(url, this.purgeCacheCompleted.bind(this))
		},

		purgeCacheCompleted (data) {
			this.setup()
		},

		fetchSpecificCache (e) {
			this.startedInt++
			var target = e.currentTarget
			var pageUrl = target.getAttribute('data-url')

			// mark the correct page with a loading status
			for (var key in this.sitemapFiltered) {
				for (var i = this.sitemapFiltered[key].length - 1; i >= 0; i--) {
					if (this.sitemapFiltered[key][i].page_url === pageUrl) this.sitemapFiltered[key][i].loading = true
				}
			}

			var domain = this.user.project.domains[Object.keys(this.user.project.domains)[0]].domain
			var url = '/cms/api/cache/createPage?url=' + domain + pageUrl
			xhrModule.get(url, this.fetchSpecificCacheCompleted.bind(this))

			// update interface with loader
			this.$forceUpdate()
		},

		fetchSpecificCacheCompleted (data) {
			this.finishedInt++
			if (this.startedInt === this.finishedInt) {
				this.fetchCacheFiles()
			}
		},

		toggleCaching (e) {
			var target = e.currentTarget
			var cacheUrl = target.getAttribute('data-url')
			var active = target.classList.contains('active')

			var urlParam = 'enable'
			if (active) urlParam = 'disable'
			target.classList.toggle('active')

			var url = '/cms/api/cache/' + urlParam + '?url=' + cacheUrl
			xhrModule.get(url, this.toggleCachingComplete.bind(this))
		},

		toggleCachingComplete (data) {
			this.setup()
		},

		deleteSpecificCache (e) {
			var target = e.currentTarget
			var pageUrl = target.getAttribute('data-id')

			// 1 specifieke cache files verwijderen
			var domain = this.user.project.domains[Object.keys(this.user.project.domains)[0]].domain
			var url = '/cms/api/cache/deletePage?url=' + domain + pageUrl
			xhrModule.get(url, this.deleteSpecificCacheCompleted.bind(this))
		},

		deleteSpecificCacheCompleted (data) {
			this.setup()
		}
	}
}

</script>
